import { z } from 'zod';

export const renameClipFilesRequestSchema = z.object({
  clipId: z.number().int().positive(),
  oldBaseLocalPath: z.string().nullable(),
  oldVerticalLocalPath: z.string().nullable(),
  oldBasePath: z.string().nullable(),
  oldVerticalPath: z.string().nullable(),
  newTitle: z.string().min(1),
});

export type IRenameClipFilesRequest = z.infer<typeof renameClipFilesRequestSchema>;
